import { useIntl } from 'react-intl';

import './style.scss';
type CustomTenorFieldProps = {
  id: string;
  label: string;
  onClose: () => void;
};

export function CustomTenorField({ id, label, onClose }: CustomTenorFieldProps) {
  const { formatMessage } = useIntl();
  const value = formatMessage({ id: 'form.Tenor.custom' });

  return (
    <div className="bg-lvl1 flex-y h-100 justify-content-between">
      <label
        htmlFor={id}
        className="input-label text-secondary px-12px w-auto flex-x align-items-center tenor-label-height"
      >
        {label}
      </label>

      <div className="flex-x">
        <input
          id={id}
          type="text"
          value={value}
          className="form-control form-control-lg fs-1 fw-medium shadow-none pb-2"
          readOnly
        />

        <button
          className="btn btn-flat-secondary btn-lg btn-icon config-action px-3"
          aria-label="close custom tenor input"
          onClick={onClose}
        >
          <i className="icon" aria-hidden="true">
            close
          </i>
        </button>
      </div>
    </div>
  );
}
